import { useMutation, useQuery, useQueryClient } from "react-query";
import { request } from "../../../utilities/fetch";

const url = "/config/absenceTrackingCategories";

export const useFetchAbsenceTrackingCategories = ({ account }) =>
  useQuery(
    ["absenceTrackingCategories", account],
    () => request({ url, params: { account } }),
    { select: (response) => response?.data || [], staleTime: 300000 },
  );

export const useSaveAbsenceTrackingCategory = ({ account }) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ ref, label, colour }) =>
      request({
        url: ref ? `${url}/${encodeURIComponent(ref)}` : url,
        method: ref ? "patch" : "post",
        params: { account },
        data: { label, colour },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["absenceTrackingCategories", account]);
        queryClient.invalidateQueries(["config", account]);
      },
    },
  );
};

export const useDeleteAbsenceTrackingCategory = ({ account }) => {
  const queryClient = useQueryClient();
  return useMutation(
    (ref) =>
      request({
        url: `${url}/${encodeURIComponent(ref)}`,
        method: "delete",
        params: { account },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["absenceTrackingCategories", account]);
        queryClient.invalidateQueries(["config", account]);
      },
    },
  );
};
